import React from 'react';
import Breadcrumbs, { Breadcrumb } from 'components/common/Breadcrumb';
import PrivacyPolicy from 'components/landing/PrivacyPolicy';

/**
 * Props for Breadcrumb
 */
const breadcrumbs: Breadcrumb[] = [
    {
        name: 'トップページ',
        url: '/kisoku',
    },
    {
        name: '個人情報取扱規約',
        url: '/kisoku/privacy-policy',
    },
];

const TermsOfUse = () => {
    return (
        <>
            <section className='breadcrumbs'>
                <Breadcrumbs breadcrumb={breadcrumbs}/>
            </section>
            <section className='static-content'>
                <PrivacyPolicy/>
            </section>
        </>
    );
};

export default TermsOfUse;
